import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyComponent = lazyForPaint(
	() => import(/* webpackChunkName: "jira-technical-planner" */ './ui/index.tsx'),
);

export const Component = () => (
	<Placeholder name="jira-technical-planner" fallback={null}>
		<LazyComponent />
	</Placeholder>
);

export default Component;
